export enum MFASetupStatus {
  /// <summary>
  /// 初回ログイン時
  /// </summary>
  InitLogin = 0,
  /// <summary>
  /// 未登録
  /// </summary>
  NotSetup = 1,
  /// <summary>
  /// 一度でもMFAを登録完了した
  /// 登録後MFAを削除してもこの状態
  /// </summary>
  Completed = 2,
}
